import { type ReactElement } from 'react';
import { CodeRef } from '@vello/web-theme';
import { useT } from '../i18n/provider';

/**
 * D619: a long identifier in the Admin — its short tail with the whole value on hover; `copy` adds the copy button (never inside a
 * clickable row: the row is a button). `full` writes the whole value (a drawer has the room). Labels come from the catalog.
 */
export function IdRef({ value, copy = false, full = false }: { readonly value: string; readonly copy?: boolean; readonly full?: boolean }): ReactElement {
  const { t } = useT();
  return <CodeRef value={value} full={full} {...(copy ? { copyLabel: t('ui.copy'), copiedLabel: t('ui.copied') } : {})} />;
}
